"use client";
import Link from "next/link";
import Image from "next/image";
import { Button } from "@/components/atoms/button";
import { InputPhone } from "@/components/molecules/phone";
import { Strong, Text } from "@/components/atoms/text";
import { FieldGroup, Field, Label } from "@/components/atoms/fieldset";
import { Tabs, TabsList, TabsTrigger } from "@/components/atoms/tabs";
import { Logo as CentiLogo } from "@/components/atoms/logo";
import { Divider } from "antd";
import { FormProvider } from "react-hook-form";
import { useSignInForm } from "../hooks/useSignInForm";
import { PasswordInput } from "@/components/molecules/password-input";
import FieldErrorMessage from "@/components/molecules/error-message";
import { DEFAULT_LOGIN_REDIRECT_PATH } from "@/lib/auth/routes";

export function SignInForm() {
  const {
    methods,
    errors,
    register,
    loadingSignIn,
    loadingGoogleSignIn,
    setPath,
    onSubmit,
    signInWithGoogle,
    showGoogle,
  } = useSignInForm();

  return (
    <>
      <FormProvider {...methods}>
        <form aria-label="form" onSubmit={onSubmit}>
          <FieldGroup className="!space-y-4">
            {/* <Tabs
              defaultValue={DEFAULT_LOGIN_REDIRECT_PATH}
              onValueChange={(value) => setPath(value)}>
              <TabsList className="grid w-full grid-cols-2 -mt-3 mb-2">
                <TabsTrigger value="/procure">
                  <CentiLogo fill="black" width={55} />
                  <p className="text-[0.80rem] mt-0.5">Procure</p>
                </TabsTrigger>
                <TabsTrigger value="/">
                  <CentiLogo width={55} />
                  <p className="text-[0.80rem] mt-0.5">Hub</p>
                </TabsTrigger>
              </TabsList>
            </Tabs> */}
            <Field className="!pt-1">
              <Label>Phone number</Label>
              <InputPhone {...register("phone")} />
              <FieldErrorMessage error={errors?.phone} />
            </Field>
            <Field>
              <Label>Password</Label>
              <PasswordInput
                register={register("password")}
                placeholder="Enter your password"
                id="password"
              />
              <FieldErrorMessage error={errors?.password} />
            </Field>
          </FieldGroup>
          <Text className="text-right pt-3">
            <Link href="/forgot" className="hover:underline hover:text-dark">
              Forgot password?
            </Link>
          </Text>
          <div className="w-full mt-6">
            <Button
              full
              type="submit"
              className="!h-11"
              loading={loadingSignIn}
              disabled={loadingSignIn}>
              Sign in
            </Button>
          </div>
          {showGoogle && (
            <>
              <Divider
                plain
                style={{ fontWeight: "500" }}
                className="animate-fadeIn duration-1000">
                or
              </Divider>
              <Button
                full
                onClick={signInWithGoogle}
                className="!h-11 !rounded-lg animate-fadeIn duration-1000"
                loading={loadingGoogleSignIn}
                disabled={loadingGoogleSignIn}>
                <Image
                  src="/images/google-icon.svg"
                  width={15}
                  height={15}
                  alt="Google"
                />
                Sign in with Google
              </Button>
            </>
          )}
          <Text className="text-center pt-6">
            Don&apos;t have an account?{" "}
            <Strong>
              <Link href="/register" className="hover:underline">
                Register
              </Link>
            </Strong>
          </Text>
        </form>
      </FormProvider>
    </>
  );
}
